import classNames from 'classnames'
import React from 'react'

import { HStack } from '~/components/elements/HStack'
import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

import styles from './TableContainer.css'

export type TableContainerProps = React.PropsWithChildren<{
  className?: string
  'data-testid'?: string
  header?: React.ReactNode
  id?: string
  title?: string
}>

export const TableContainer = ({
  children,
  className,
  'data-testid': dataTestId = 'components-features-table-container',
  header,
  id,
  title = '',
}: TableContainerProps) => (
  <VStack
    className={classNames(styles.root, className)}
    data-testid={dataTestId}
    id={id}
    inline={true}
    spacing={1}
  >
    <HStack className={styles.header} spacing={2}>
      <Typography fontWeight={700} variant="heading2">
        {title}
      </Typography>

      <HStack spacing={2}>{header}</HStack>
    </HStack>

    {children}
  </VStack>
)
